import { IGoogleDocsDTO } from '@/api/google/types/google-docs-dto';
import { EExternalEditorType } from '@/enums/ExternalEditorType';
import { IDocument } from '@/types/Document';

export class GoogleDocsHelper {
  static convertDTOs(documents: IGoogleDocsDTO[]): Partial<IDocument>[] {
    return documents.map((document: IGoogleDocsDTO) => ({
      id: document.id,
      name: document.name,
      thumbUrl: document.thumb_url,
      type: document.type,
      externalEditorType: EExternalEditorType[document.external_editor_type],
      createdAt: document.created_at,
    }));
  }
}
